@if (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM)) {
  <form (ngSubmit)="onAddLink()"
    [formGroup]="form"
    class="mb-4"
    >
    <h4>{{'ITEM.DETAIL.LINK_NEW_ITEM_TO_SUIT' | translate}}</h4>
    <div class="d-flex align-items-center flex-wrap gap-2">
      <mat-form-field appearance="outline"
        class="form-field-condensed">
        <mat-label>{{'COMMON.LABEL.INVENTORY' | translate}}</mat-label>
        <input matInput
          formControlName="inventory">
      </mat-form-field>
      <!-- <mat-form-field appearance="outline"
      class="mx-3">
      <mat-label>{{'ITEM.DETAIL.SUIT_TYPOLOGY' | translate}}</mat-label>
      <mat-select formControlName="typologyId"
        (selectionChange)="onChangeSuitTypology($event)">
        <mat-option *ngFor="let typology of storeService.store.filters.suitTypologies"
          [value]="typology.id">
          {{typology.name}}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    <button mat-raised-button
      color="primary"
      [disabled]="!form.valid"
      type="submit">
      {{'ITEM.DETAIL.LINK_ITEM_TO_SUIT' | translate}}
    </button>
  </div>
</form>
}

@if (selectedItem.suitItems?.length) {
  <div class="items-list"
    >
    <h4>{{'ITEM.DETAIL.LINKED_SUIT' | translate}}</h4>
    @for (item of selectedItem.suitItems; track item) {
      <mpa-linked-item-row
        [item]="item"
      (removeLink)="onRemoveLink($event)"></mpa-linked-item-row>
    }
  </div>
}

@if (!selectedItem?.suitItems?.length) {
  <h4>{{'ITEM.DETAIL.EMPTY_ITEM_LINKED_SUIT' | translate}}</h4>
}